import { NavigateOptions, useSearchParams } from 'react-router-dom';

export const URLParamsName = {
  LEAD_UID: 'leadUid',
  THREAD_UID: 'threadUid',
  PROPERTY_UID: 'propertyUid',
};

const useSearchURLParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const setParameter = (
    paramsName: (typeof URLParamsName)[keyof typeof URLParamsName],
    value: string,
    navigateOpts?: NavigateOptions | undefined,
  ) => {
    searchParams.set(paramsName, value);
    setSearchParams(searchParams, navigateOpts);
  };

  const deleteParameter = (
    paramsName: (typeof URLParamsName)[keyof typeof URLParamsName],
  ) => {
    searchParams.delete(paramsName);
    setSearchParams(searchParams);
  };

  const getParameter = (
    paramsName: (typeof URLParamsName)[keyof typeof URLParamsName],
  ) => {
    return searchParams.get(paramsName);
  };

  return {
    setParameter,
    deleteParameter,
    getParameter,
  };
};

export default useSearchURLParams;
